import { Button, Modal, Typography } from 'antd';

import { IMPACT_CALCULATION_TITLE } from './constants';

type CalculationModalProps = {
  open: boolean;
  onClose: () => void;
};

function CalculationModal({ open, onClose }: CalculationModalProps) {
  return (
    <Modal
      wrapProps={{ id: 'impact-meter-calculation' }}
      open={open}
      onCancel={onClose}
      title={IMPACT_CALCULATION_TITLE}
      footer={
        <Button type='primary' onClick={onClose}>
          Entendi
        </Button>
      }
    >
      <div className='flex flex-col gap-4'>
        <Typography.Text strong>
          Este número é uma estimativa de referência e não deve ser interpretado como um dado absoluto.
        </Typography.Text>
        <div className='rounded-(--uizz-antd-border-radius) bg-(--uizz-antd-color-primary-bg) px-4 py-3'>
          <Typography.Text className='text-(--uizz-antd-color-primary)'>
            Pessoas alcançadas diretamente × 3 = impacto estimado
          </Typography.Text>
        </div>

        <Typography.Paragraph>
          Primeiro, identificamos as{' '}
          <Typography.Text strong>pessoas únicas relacionadas à sua jornada na Eduzz</Typography.Text> a partir dos
          dados disponíveis em nossas bases, como faturas pagas e alunos nos ambientes de entrega considerados pelo
          Impactômetro. Sempre que existe uma identificação confiável, buscamos evitar que a mesma pessoa seja contada
          mais de uma vez.
        </Typography.Paragraph>

        <Typography.Paragraph>
          Depois, aplicamos o fator <Typography.Text strong>3</Typography.Text>. Esse multiplicador utiliza como
          referência a média de aproximadamente{' '}
          <Typography.Text strong>três pessoas por domicílio no Brasil</Typography.Text> e parte da ideia de que o
          conhecimento, produto ou experiência que chega diretamente a uma pessoa também pode reverberar para outras
          pessoas ao seu redor.
        </Typography.Paragraph>

        <Typography.Paragraph>
          <Typography.Text strong>
            Isso não significa que cada pessoa alcançada impactou exatamente outras duas pessoas.
          </Typography.Text>{' '}
          O fator 3 é utilizado apenas para construir uma estimativa de alcance ampliado.
        </Typography.Paragraph>

        <Typography.Paragraph>
          Como o cálculo combina informações de diferentes bases e depende da identificação disponível em cada uma
          delas,{' '}
          <Typography.Text strong>
            podem existir diferenças, duplicidades não identificadas, dados ainda não processados ou outras imprecisões
          </Typography.Text>.
        </Typography.Paragraph>

        <Typography.Paragraph>
          Por isso, o Impactômetro deve ser entendido como{' '}
          <Typography.Text strong>uma referência para dimensionar o alcance da sua trajetória na Eduzz</Typography.Text>
          {', '}e não como contagem exata de todas as pessoas impactadas.
        </Typography.Paragraph>
      </div>
    </Modal>
  );
}

export default CalculationModal;
